<template>
  <div class="second-step-component">
    <menu-items-list :items="computedMenuItems" :loading="isLoading">
      <template v-slot:before-menu-items>
        <food-categories />
      </template>
    </menu-items-list>
    <!--    <template v-if="false">-->
    <!--      <food-window-->
    <!--        v-if="showFoodWindow"-->
    <!--        :item="currentFoodItem"-->
    <!--      />-->

    <!--      <section v-show="!showFoodWindow && !showPromotionsWindow">-->
    <!--        <food-categories />-->
    <!--        <div class="menu-items-content">-->
    <!--          <v-loader v-if="isLoading" absolute />-->
    <!--          <template v-else>-->
    <!--            <v-row v-if="menuItems.length" class="menu-items">-->
    <!--              <v-col-->
    <!--                v-for="item in computedMenuItems"-->
    <!--                :key="item.id"-->
    <!--                sm="4"-->
    <!--                xl="3"-->
    <!--              >-->
    <!--                <food-card-->
    <!--                  :item="item"-->
    <!--                  new-->
    <!--                  bonus-->
    <!--                  child-->
    <!--                  @openFoodWindow="openFoodWindow"-->
    <!--                />-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <span v-else class="d-block display-3 text-center">Ничего не найдено</span>-->
    <!--          </template>-->
    <!--        </div>-->
    <!--      </section>-->
    <!--    </template>-->
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCategories from '@/components/order-processing/order-components/food-categories/FoodCategories'
  import FoodCard from '@/components/order-processing/order-components/first-step/FoodCard.vue'
  import FoodWindow from '@/components/order-processing/order-components/first-step/FoodWindow'
  import OrderEdit from '@/mixins/order-edit'
  import MenuItemsList from '@/components/order-processing/order-components/restourant-menu/MenuItemsList.vue'

  export default {
    name: 'SecondStep',
    components: {
      MenuItemsList,
      VLoader,
      FoodCategories,
      FoodCard,
      FoodWindow,
    },
    mixins: [
      OrderEdit,
    ],
    data () {
      return {
        currentFoodItem: {},
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        /*  showFoodWindow: state => state.newOrder.showFoodWindow,
        showPromotionsWindow: (state) => state.newOrder.showPromotionsWindow,
        isLoading: (state) => state.newOrder.isMenuItemsLoading,
        menuItems: (state) => state.newOrder.menuItemsList || [],
        searchMenu: state => state.newOrder.searchMenu,
        allMenuItemsList: state => state.newOrder.allMenuItemsList, */
      }),
      /* ...mapGetters({
        allMenuItems: 'newOrder/getAllMenuItems',
      }), */
      allMenuItems () {
        return this.$store.getters[this.orderEditPrefix + '/getAllMenuItems']
      },
      showFoodWindow () { return this.orderState.showFoodWindow },
      showPromotionsWindow () { return this.orderState.showPromotionsWindow },
      isLoading () { return this.orderState.isMenuItemsLoading },
      menuItems () { return this.orderState.menuItemsList || [] },
      searchMenu () { return this.orderState.searchMenu },
      allMenuItemsList () { return this.orderState.allMenuItemsList },
      computedMenuItems () {
        if (this.searchMenu) {
          return this.allMenuItems.filter(item => {
            const itemName = item.name.toLowerCase()
            const searchString = this.searchMenu.toLowerCase()
            return itemName.includes(searchString)
          })
        }
        return this.menuItems
      },
    },
    beforeDestroy () {
      this.$store.commit(this.orderEditPrefix + '/setFoodWindowState', false)
    },
    methods: {
      openFoodWindow (item) {
        this.currentFoodItem = item
      },
    },
  }
</script>

<style lang="less" scoped>
.second-step-component {
  background-color: transparent;

  .menu-items {
    position: relative;
    z-index: 0;

  }

  .menu-items-content {
    position: relative;
    min-height: 80vh;
  }

}
</style>
